import React from "react";
import { useTranslation } from "react-i18next";
import { faMultiply } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Tag.scss";
import Tooltip from "../tooltip/Tooltip";

interface IProps {
    variant: TTagVariant | string;
    iconOnly?: boolean; // Makes the tag icon only
    children?: React.ReactNode | undefined;
    onClick?: (e?: any) => void; // Makes the tag clickable
    onDelete?: (e?: any) => void; // Makes the tag deletable
}

export type TTagVariant =
    | "grey"
    | "dark-grey"
    | "interactive-green"
    | "green"
    | "dark-green"
    | "orange"
    | "dark-orange"
    | "blue"
    | "source-light-blue"
    | "source-dark-blue"
    | "dark-blue"
    | "yellow"
    | "light-red"
    | "red"
    | "dark-red"
    | "white"
    | "purple"
    | "pink";

export default function Tag(props: IProps) {
    const { t } = useTranslation();

    if (props.onClick) {
        return (
            <button
                style={{ paddingRight: props.onDelete ? 0 : "8px" }}
                className={`userful-tag-wrapper ${props.variant ? props.variant + "-userful-tag" : ""} ${props.iconOnly ? "userful-tag-icon-button" : ""}`}
                onClick={props.onClick}
            >
                {props.children}
                {!props.iconOnly && props.onDelete && (
                    <Tooltip title={t("Shared.remove")}>
                        <button className="userful-clickable-tag-wrapper" onClick={props.onDelete}>
                            <FontAwesomeIcon icon={faMultiply} />
                        </button>
                    </Tooltip>
                )}
            </button>
        );
    }

    return (
        <div
            style={{ paddingRight: props.onDelete ? 0 : "8px" }}
            className={`userful-tag-wrapper ${props.variant ? props.variant + "-userful-tag" : ""} ${props.iconOnly ? "userful-tag-icon-button" : ""}`}
        >
            {props.children}
            {!props.iconOnly && props.onDelete && (
                <Tooltip title={t("Shared.remove")}>
                    <button className="userful-clickable-tag-wrapper" onClick={props.onDelete}>
                        <FontAwesomeIcon icon={faMultiply} />
                    </button>
                </Tooltip>
            )}
        </div>
    );
}
